import { Injectable } from '@angular/core';

import { WorkflowStep } from '@osos/shared/api';
import { FactoryBase } from '../../bases';
import { ParserFactory } from '../../services';

import { WorkflowStepPresenterModel } from '@osos/shared/types';
import { WorkflowStepParserService } from '../../parsers/workflow-step-parser/workflow-step-parser.service';

@Injectable()
export class WorkflowStepFactoryService extends FactoryBase<
  WorkflowStep,
  WorkflowStepPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: WorkflowStepParserService,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: WorkflowStepPresenterModel): WorkflowStep {
    //@TODO use presenter.specificationVersion
    const parser = this.getParser(WorkflowStep, WorkflowStepPresenterModel);
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: WorkflowStep): WorkflowStepPresenterModel {
    //@TODO use model.specificationVersion
    const parser = this.getParser(WorkflowStep, WorkflowStepPresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
}
